<div class="ideal-use-case-container">
  <div><label class="info-header">{{title}}</label></div>
  <div class="label-container"><label class="info-label">{{useCaseOption.title}}</label></div>
  <p class="info-paragraph">
    {{useCaseOption.subtitle}}
  </p>
</div>

